import {
	InteractionsIconMapMedium,
	InteractionsIconMapBig,
} from "@/common/helpers";

import {
	HistoryItemIconProps as InteractionComposedIconProps,
	IconSize,
} from "./types";
import { useStyle } from "./style";
import { mergeClasses } from "@fluentui/react-components";
import {
	ArrowDownLeftFilled,
	ArrowDownLeftRegular,
	ArrowUpRightFilled,
	ArrowUpRightRegular,
	CircleFilled,
	ClockRegular,
	TextHanging20Regular,
	TextHanging24Regular,
} from "@fluentui/react-icons";
import { useMemo } from "react";

export const InteractionComposedIcon = (
	props: InteractionComposedIconProps
) => {
	const {
		interactionType,
		isMissed,
		isInbound,
		isParked,
		size,
		hasUnreadIcon,
		hideDirectionArrow,
	} = props;

	const classes = useStyle();
	const bottomIcon = useMemo(() => {
		if (size == IconSize.Large) {
			return InteractionsIconMapBig[interactionType];
		}

		return InteractionsIconMapMedium[interactionType];
	}, [size, interactionType]);

	const arrowRightIcon = useMemo(() => {
		if (size == IconSize.Large) {
			return <ArrowUpRightFilled fontSize={11} />;
		}

		return <ArrowUpRightRegular fontSize={10} />;
	}, [size, interactionType]);

	const arrowLeftIcon = useMemo(() => {
		if (size == IconSize.Large) {
			return <ArrowDownLeftFilled fontSize={11} />;
		}

		return <ArrowDownLeftRegular fontSize={10} />;
	}, [size, interactionType]);

	const clockIcon = useMemo(() => {
		if (size == IconSize.Large) {
			return <ClockRegular fontSize={11} />;
		}

		return <ClockRegular fontSize={10} />;
	}, [size, interactionType]);

	const parkicon = useMemo(() => {
		if (size == IconSize.Large) {
			return <TextHanging24Regular />;
		}

		return <TextHanging20Regular />;
	}, [size, interactionType]);

	const upperIcon = useMemo(() => {
		if (isParked) {
			return parkicon;
		}

		if (isMissed) {
			return clockIcon;
		}

		// hideDirectionArrow removes only the direction arrow (the My
		// interactions list shows it inline next to the contact info instead);
		// the park/missed status badges above still render regardless.
		if (hideDirectionArrow) {
			return null;
		}

		if (isInbound) {
			return arrowLeftIcon;
		}

		return arrowRightIcon;
	}, [isMissed, isInbound, isParked, hideDirectionArrow]);

	// Without any upper badge the channel icon is centered and enlarged.
	const hasUpperBadge = upperIcon !== null;

	return (
		<div className={classes.composedIcon}>
			{hasUpperBadge && (
				<div
					className={mergeClasses(
						classes.upperIcon,
						size == IconSize.Large && classes.bold,
						isMissed && classes.redHighlight
					)}
				>
					{upperIcon}
				</div>
			)}
			{hasUnreadIcon && (
				<div
					className={mergeClasses(
						classes.middleIcon,
						classes.highlighted,
						!hasUpperBadge && classes.middleIconCentered
					)}
				>
					<CircleFilled fontSize={!hasUpperBadge ? 9 : 7} />
				</div>
			)}
			<div
				className={mergeClasses(
					classes.bottomIcon,
					!hasUpperBadge && classes.bottomIconCentered
				)}
			>
				{bottomIcon}
			</div>
		</div>
	);
};
